// https://www.radix-ui.com/docs/primitives/components/dropdown-menu

import * as React from 'react'
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu'

export function Root(props: RadixDropdownMenu.DropdownMenuProps) {
  return <RadixDropdownMenu.Root {...props} />
}

export function Trigger(props: RadixDropdownMenu.DropdownMenuTriggerProps) {
  return <RadixDropdownMenu.Trigger {...props} />
}

export function Portal(props: RadixDropdownMenu.DropdownMenuPortalProps) {
  return <RadixDropdownMenu.Portal {...props} />
}

export const Content = ({
  ref,
  ...props
}: RadixDropdownMenu.DropdownMenuContentProps & {
  ref?: React.RefObject<HTMLDivElement | null>
}) => {
  // We want to stop the auto focus on click outside, but keep it on Escape from keyboard navigation
  const closedByClickRef = React.useRef(false)

  return (
    <RadixDropdownMenu.Content
      ref={ref}
      onCloseAutoFocus={e => {
        if (closedByClickRef.current) {
          e.preventDefault()
          closedByClickRef.current = false
        }
        props.onCloseAutoFocus?.(e)
      }}
      onInteractOutside={e => {
        if (e.detail.originalEvent.type === 'pointerdown') {
          closedByClickRef.current = true
        }
        props.onInteractOutside?.(e)
      }}
      {...props}
    />
  )
}
Content.displayName = 'DropdownMenuContent'

export function Item(props: RadixDropdownMenu.DropdownMenuItemProps) {
  return <RadixDropdownMenu.Item {...props} />
}

export const Sub = RadixDropdownMenu.Sub

export const SubTrigger = RadixDropdownMenu.SubTrigger

export const SubContent = RadixDropdownMenu.SubContent

export function Label(props: RadixDropdownMenu.DropdownMenuLabelProps) {
  return <RadixDropdownMenu.Label {...props} />
}
